// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PinInput } from '@mantine/core';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { IconArrowLeft, IconFingerprint } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function OtpHeroImage() {
  const [otp, setOtp] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP submitted:', otp);
  };

  return (
    <AuthLayoutWrapper
      variant="cover"
      backgroundImage="https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1920&q=80"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/otp"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #8b5cf6, #d946ef)',
              }}
            >
              <IconFingerprint size={28} color="white" />
            </Center>
            <Title order={2} ta="center">Verify code</Title>
            <Text c="dimmed" size="sm" ta="center">
              Enter the 6-digit code
            </Text>
          </Stack>
        </Center>

        {/* OTP Input */}
        <form onSubmit={handleSubmit}>
          <Stack gap="lg">
            <Center>
              <PinInput
                length={6}
                size="lg"
                value={otp}
                onChange={setOtp}
                type="number"
                oneTimeCode
              />
            </Center>

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: 'violet', to: 'fuchsia' }}
              disabled={otp.length !== 6}
            >
              Verify
            </Button>
          </Stack>
        </form>

        {/* Resend */}
        <Text ta="center" size="sm" c="dimmed">
          Didn't get a code?{' '}
          <Anchor component="button" type="button" fw={500}>
            Resend
          </Anchor>
        </Text>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/app/demo/auth-pages/login/cover" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to login
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
